// extracted by mini-css-extract-plugin
export default {"container":"style_container__uMaPm","image":"style_image__q2vMM","textContainer":"style_textContainer__vs7BG","title":"style_title__8F8PZ","text":"style_text__DdM+Z"};